import { useSyncExternalStore, useMemo, useCallback } from 'react';
import { orchestratorStorage } from '../utils/orchestratorStorage';
export const useOrchestratorState = () => {
  // Use React's useSyncExternalStore to eliminate a second source of truth like useState
  // This ensures the component always reflects the current orchestrator storage state
  const {
    canRenderNudge,
    activeComponentId
  } = useSyncExternalStore(
  // Subscribe function
  callback => orchestratorStorage.subscribe(callback),
  // The current state of the orchestrator storage
  () => orchestratorStorage.getData());
  const setActiveComponent = useCallback((componentId, weight) => orchestratorStorage.setActiveComponent(componentId, weight), []);
  const removeActiveComponent = useCallback(componentId => orchestratorStorage.removeActiveComponent(componentId), []);
  const allowRender = useCallback(() => orchestratorStorage.allowRender(), []);
  return useMemo(() => ({
    canRenderNudge,
    activeComponentId,
    setActiveComponent,
    removeActiveComponent,
    allowRender
  }), [canRenderNudge, activeComponentId, setActiveComponent, removeActiveComponent, allowRender]);
};